<template>
	<div class="agenda">
		<table class="table">
			<colgroup>
				<col class="col-1" style="width: 180px">
				<col class="col-2">
				<col class="col-3" style="width: 400px">
			</colgroup>
			<thead>
				<tr>
					<td>时间</td>
					<td>主题</td>
					<td>演讲人</td>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>
						<em>09:00</em>
						<span> - </span>
						<em>09:30</em>
					</td>
					<td>签到</td>
					<td>/</td>
				</tr>
				<tr>
					<td>
						<em>09:30</em>
						<span> - </span>
						<em>10:10</em>
					</td>
					<td>Easy, Scalable, Fault-Tolerant Stream Processing with Structured Streaming in Apache Spark </td>
					<td>Tathagata Das / Databricks，Apache Spark PMC</td>
				</tr>
				<tr>
					<td>
						<em>10:10</em>
						<span> - </span>
						<em>10:50</em>
					</td>
					<td>实时融合大数据技术方案Spark+CarbonData</td>
					<td>蔡强 / 华为大数据架构师 Apache CarbonData PMC和Committer</td>
				</tr>
				<tr>
					<td>
						<em>10:50</em>
						<span> - </span>
						<em>11:00</em>
					</td>
					<td>短休</td>
					<td>/</td>
				</tr>
				<tr>
					<td>
						<em>11:00</em>
						<span> - </span>
						<em>11:40</em>
					</td>
					<td>美团点评Flink实践与应用</td>
					<td>孙梦瑶 / 美团点评高级研发工程师</td>
				</tr>
				<tr>
					<td>
						<em>11:40</em>
						<span> - </span>
						<em>12:20</em>
					</td>
					<td>基于Flink，Spark双引擎的实时流计算服务</td>
					<td>时金魁 / 华为云技术专家</td>
				</tr>
				<tr>
					<td>
						<em>12:20</em>
						<span> - </span>
						<em>12:30</em>
					</td>
					<td>合影留念</td>
					<td>/</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>

export default {
  components: {
  },
  data () {
    return {}
  },
  computed: {
  },
  methods: {
  },
  created () {
  },
  mounted () {
  }
}
</script>
<style>
	/*@media screen and (min-width: 769px)*/
	em{
		font-style: normal;
	    font-weight: 400;
	}
	.agenda{
		width: 100%;
		border-top: solid 1px #2D333F;
		border-bottom: solid 1px #2D333F;
	}
	.agenda table{
		width: 100%;
	}
	thead{
		width: 100%;
		border-bottom: solid 1px #2D333F;
	}
	thead td{
		color: #00c8dc;
		font-size: 18px;
		padding-top: 19px;
		padding-bottom: 11px;
		font-weight: 600;
	}
	.table tbody td {
	    color: #fff;
	    font-size: 14px;
	    padding-top: 13px;
	    padding-bottom: 13px;
	    vertical-align: top;
	    font-weight: 600;
	}
	.table tbody td em, .table tbody td span{
		font-weight: 600;
	}
	.table tr td:nth-child(1) {
	    border-right: 1px solid #2D333F;
	}
	.table tr td:nth-child(2) {
	    border-right: 1px solid #2D333F;
	}
	
	.table td {
	    border-bottom: 1px solid #2D333F;
	    padding-left: 40px;
	    padding-right: 40px;
	}
	@media screen and (max-width: 768px) {
		.table tbody td{
			margin: 0;
			padding: 0; 
		}
		.agenda{
			width: 100%;
			border-top: none;
			border-bottom: none;
		}
		table{
			border-collapse: collapse;
    		border-spacing: 0;
		}
		thead{ display: none;}
		.table tbody tr{ display: block;} .table tbody tr td{ display: block;}
		.table tr td:nth-child(1),.table tr td:nth-child(2){ border-right: none; }
		.table tbody tr td{ border-bottom: none; }

		
		.table tbody tr{
			position: relative;
			margin-left: 60px;
		    border-bottom: 0;
		    border-left: 1px solid #333;
		    padding-top: 0;
		    box-sizing: border-box;
		    width: auto;
		    min-height: 42px;
		    padding-left: 15px;
		    padding-bottom: 25px;
		}
		.table tbody tr td:nth-child(1){
			display: block;
		    font-size: 13px;
		    line-height: 1;
		    position: absolute;
		    left: -60px;
		    top: 2px;
		    width: auto;
		    text-align: center;
		    color: #c1c1c1;
		}
		.table tbody tr td:nth-child(1) em,.table td:nth-child(1) span{
			display: block;
			font-style: normal;
			font-weight: 400;
		}
		.table tbody tr td:nth-child(1) span{
			margin-bottom: 2px;
		}
		.table tbody tr td:nth-child(2){
			font-size: 16px;
			line-height: 1.2;
			color: #fff;
		}
		.table tbody tr td:nth-child(3){
			font-size: 13px;
			line-height: 1.4;
			margin-top: 8px;
			color: #006eff;
			display: inline-block;
			vertical-align: top;
		}
		.table tbody tr td:nth-child(4){
			font-size: 13px;
		    line-height: 1.4;
		    margin-top: 8px;
		    color: #006eff;
		    display: inline-block;
		    vertical-align: top;
		}
	}
</style>



// WEBPACK FOOTER //
// src/scheduleb.vue